import {
  InputField,
  LabelField,
  MyRadioGroup,
  SelectField,
  Text,
  TextareaField,
} from "components";
import { Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import MaskedInput from "react-text-mask";

import { useAuth0 } from "@auth0/auth0-react";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import SwitchComp from "components/switch";
import {
  getDateFormat,
  getDateFormatForDatePicket,
  maskDate,
} from "helper/dateFormat";
import { useSearch } from "hook";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import MyButton from "../../../components/MyButton";

import CircularProgress from "@mui/material/CircularProgress";
import InfoTooltip from "components/InfoTooltip";
import { MultiSelect } from "components/MultiSelect/MultiSelect";
import PastoralService from "Lib/API/PastoralApi";
import NewEventSuccess from "./NewEventSuccess";
import "./styles.scss";

const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
};

const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const NewEvent = ({
  closeModal,
  setCallEventsAgain,
  handleClose,
  ...props
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const userContactId = localStorage.getItem("user_contact_id")
    ? JSON.parse(localStorage.getItem("user_contact_id"))
    : null;

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    dateFormat || "mm/dd/yyyy"
  );

  const [search, setSearch] = useState(undefined);
  const { searchAction } = useSearch({ action: setSearch });
  const [data, setData] = useState(false);
  const [userData, setUserData] = useState([]);
  const [totalUsers, setTotalUSers] = useState("");
  const [successFull, setSuccessFull] = useState(false);
  const [responseData, setResponseData] = useState(false);
  const [createEventLoading, setCreateEventLoading] = useState(false);
  const [getEventUsersLoading, setGetEventUsersLoading] = useState(false);
  const [getEventTypesLoading, setGetEventTypesLoading] = useState(false);
  const [getMembersLoading, setGetMembersLoading] = useState(false);
  const [successEventData, setSuccessEventData] = useState([]);
  const [successEventId, setSuccessEventId] = useState(null);
  const [updateEventLoading, setUpdateEventLoading] = useState(false);

  React.useEffect(() => {
    fetchMyAPI(1);
    fetchMemberApi(1);
    fetchUsersApi(1);
  }, []);

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes()
      )
    );
    formik.setFieldValue(name, date);
    return date;
  }

  const fetchUsersApi = async (page) => {
    setGetEventUsersLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventUsers({ token, page })
      .then((res) => {
        if (res) {
          const formattedUserData = res?.users
            ?.filter((item) => item.easy_contact_id !== userContactId)
            .map((item) => {
              return {
                title: `${item?.type} ${
                  item?.fullName ? "- " + item?.fullName : ""
                }`,
                id: item?.id,
                easyorg: item?.easyorg,
                easy_contact_id: item?.easy_contact_id,
              };
            });
          setTotalUSers(res?.total);
          setUserData(formattedUserData);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetEventUsersLoading(false);
      });
  };

  const fetchMemberApi = async (page) => {
    setGetEventTypesLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventTypes({ token, page })
      .then((res) => {
        if (res) {
          setData(res?.eventTypes);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetEventTypesLoading(false);
      });
  };

  const fetchMyAPI = async (page) => {
    setGetMembersLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getMembers({ token, page })
      .then((res) => {
        if (res) {
          setResponseData(res?.contacts);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetMembersLoading(false);
      });
  };

  const options2 =
    responseData &&
    responseData?.map((item) => {
      return {
        label: item?.fullName,
        value: item?.id,
      };
    });

  const options =
    data &&
    data?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      memberName: { id: "", name: "" },
      eventType: { id: "", name: "" },
      isDescriptionConfidencial: false,
      isEventConfidencial: false,
      description: "",
      eventDate: "",
      account: {},
    },

    // validationSchema: AddNewAccountSchema,
  });

  const delay = (ms) =>
    new Promise((resolve) => setTimeout(() => resolve(), ms));

  const validateSubmit = () => {
    if (!formik?.values?.memberName?.id) {
      return toastr.info("Member Name is required");
    }
    if (!formik?.values?.eventType?.id) {
      return toastr.info("Event Type is required");
    }

    if (!formik?.values?.eventDate) {
      return toastr.info("Event Date is required");
    }

    onSubmit();
  };

  const formattedNotifyTo = (list) => {
    return list.map((item) => {
      return {
        id: item?.id?.toString(),
        easyorg: item?.easyorg,
        easy_contact_id: item?.easy_contact_id,
      };
    });
  };
  const onSubmit = async (values) => {
    setCreateEventLoading(true);
    await delay(2000);
    const token = await getAccessTokenSilently();
    const notifyTo = formik.values?.account.notifyTo?.length
      ? formik.values?.account.notifyTo?.[0] === "-1"
        ? formattedNotifyTo(userData)
        : formattedNotifyTo(formik.values?.account?.notifyTo)
      : undefined;

    const input = {
      memberId: formik.values?.memberName?.id.toString(),
      eventTypeId: formik.values?.eventType?.id.toString(),
      confidentialEvent: formik.values?.isEventConfidencial ?? false,
      confidentialInfo: formik.values?.isDescriptionConfidencial ?? false,
      description: formik.values.description,
      date: formik.values.eventDate,
      notifyTo,
    };

    await PastoralService.createEvent({ data: input, token })
      .then((res) => {
        setSuccessFull(true);
        setSuccessEventData(res?.data);
        setSuccessEventId(res?.eventId);
        setCallEventsAgain((prevState) => !prevState);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setCreateEventLoading(false);
      });
  };

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  const doNotGenerateHandler = async () => {
    const token = await getAccessTokenSilently();
    setUpdateEventLoading(true);
    PastoralService.updateEvent({
      eventId: successEventId,
      token,
    })
      .then((res) => {
        toastr.success("Event Updated Successfully");
        handleClose();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setUpdateEventLoading(false);
      });
  };

  const handleFormikChange = (items, formikField) => {
    formik.setFieldValue(formikField, items);
  };

  return (
    <div className="add-new-event-drawer p-14">
      {!successFull ? (
        <>
          <h1 className="NewEvent-heading text-center">New Event</h1>
          <div className="addEvent-form-form d-flex flex-column justify-content-between h-100">
            <>
              <div className="row mt-10">
                <div className="form-group Account-name-newEvent col-12 col-md-6">
                  <LabelField title={"Member Name"} mandatory={true} />
                  <Select
                    {...{
                      formik,
                      name: `memberName`,
                      mandatory: true,
                      checkValidation: false,
                    }}
                    onInputChange={(text) => searchAction(text)}
                    classNamePrefix="react-select"
                    formatOptionLabel={formatOptionLabel}
                    options={options2}
                    isLoading={getMembersLoading}
                    styles={colourStyles}
                    onChange={(value) => {
                      formik.setFieldValue(`memberName`, {
                        id: value.value,
                        name: value.label,
                      });
                    }}
                    value={{
                      label: formik.values?.memberName?.name,
                      value: formik.values?.memberName?.id,
                    }}
                    components={{ DropdownIndicator }}
                  />
                </div>
                <div className="form-group event-type-newEvent col-12 col-md-6">
                  <LabelField title={"Event Type"} mandatory={true} />
                  <Select
                    {...{
                      formik,
                      name: `eventType`,
                      mandatory: true,
                      checkValidation: false,
                    }}
                    onInputChange={(text) => searchAction(text)}
                    classNamePrefix="react-select"
                    formatOptionLabel={formatOptionLabel}
                    options={options}
                    isLoading={getEventTypesLoading}
                    onChange={(value) => {
                      formik.setFieldValue(`eventType`, {
                        id: value.value,
                        name: value.label,
                      });
                    }}
                    value={{
                      label: formik.values?.eventType?.name,
                      value: formik.values?.eventType?.id,
                    }}
                    components={{ DropdownIndicator }}
                  />
                  <div className="d-flex justify-content-between addEvent-switch">
                    <div className="d-flex align-items-center">
                      <LabelField
                        title="Is this event confidential?"
                        style={{ alignSelf: "center" }}
                      />
                      <InfoTooltip text="Marks this event as confidential, restricting who can view it in EasyCare." placement="bottom" useFixed style={{ marginLeft: '6px', transform: 'translateY(-3px)' }} />
                    </div>
                    <SwitchComp
                      checked={formik.values.isEventConfidencial}
                      handleChange={() => {
                        formik.setFieldValue(
                          "isEventConfidencial",
                          !formik.values.isEventConfidencial
                        );
                      }}
                      className="mr-0"
                    />
                  </div>
                </div>
                <div className="form-group pastoral-date-picker col-12 col-md-6">
                  <LabelField title={"Event Date"} mandatory={true} />
                  <DatePicker
                    isClearable={formik.values?.eventDate || false}
                    showIcon
                    placeholderText={placeholderFormat}
                    dateFormat={dateFormat}
                    selected={
                      formik.values?.eventDate &&
                      convertUTCToLocalDate(formik.values?.eventDate)
                    }
                    onChange={(date) => {
                      formik.setFieldValue("eventDate", date);
                      convertLocalToUTCDate(date, "eventDate");
                    }}
                    showYearDropdown
                    customInput={
                      <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={dateMask}
                        keepCharPositions={true}
                        guide={true}
                      />
                    }
                  />
                </div>
                <div className="form-group event-type-newEvent multi-select col-12 col-md-6">
                  <div className="d-flex align-items-center">
                    <LabelField title={"Notify To"} />
                    <InfoTooltip text="These users will be notified about this event." placement="bottom" useFixed style={{ marginLeft: '6px', transform: 'translateY(-3px)' }} />
                  </div>
                  <MultiSelect
                    isOptinal={false}
                    isCheckBoxOption={true}
                    options={userData}
                    loading={getEventUsersLoading}
                    formikField={`account[notifyTo]`}
                    setOptions={setUserData}
                    variableForSave={"title"}
                    formik={formik}
                    handleFormikChange={handleFormikChange}
                    isAccount={true}
                    formikKey={"notifyTo"}
                    searchAction={searchAction}
                    isMultiple={true}
                    width="100%"
                    total={totalUsers}
                  />
                </div>
                <div className="form-group addEvent-description  col-12">
                  <TextareaField
                    {...{
                      formik,
                      title: "Description",
                      name: `description`,
                      placeholder: "Add memo",
                      style: { resize: "none" },
                      checkValidation: true,
                      rows: 3,
                    }}
                    defaultValue={formik.values?.description}
                  />
                  <div className="d-flex justify-content-between addEvent-switch">
                    <div className="d-flex align-items-center">
                      <LabelField
                        title="Is this description confidential?"
                        style={{ alignSelf: "center", color: "#3F4254" }}
                      />
                      <InfoTooltip text="Makes this description confidential so only the event creator can view it. This is separate from the event type’s confidentiality setting." placement="bottom" useFixed style={{ marginLeft: '6px', transform: 'translateY(-3px)' }} />
                    </div>
                    <SwitchComp
                      checked={formik.values.isDescriptionConfidencial}
                      handleChange={() => {
                        formik.setFieldValue(
                          "isDescriptionConfidencial",
                          !formik.values.isDescriptionConfidencial
                        );
                      }}
                      className="mr-0"
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between mt-5">
                <div className="saveBtn-drawer">
                  <MyButton
                    type={"secondary"}
                    content={"Close"}
                    onClick={() => {
                      closeModal();
                    }}
                  />
                </div>
                <div className="saveBtn-drawer">
                  <MyButton
                    type={"primary"}
                    content={
                      createEventLoading ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <CircularProgress
                            size={20}
                            style={{
                              color: "#ffffff",
                            }}
                          />
                        </div>
                      ) : (
                        "Save"
                      )
                    }
                    onClick={() => {
                      validateSubmit();
                    }}
                    disabled={createEventLoading}
                    variant="outlined"
                  />
                </div>
              </div>
            </>
          </div>
        </>
      ) : (
        <NewEventSuccess
          eventType={formik.values.eventType?.name}
          fullName={formik.values.memberName?.name}
          closeModal={() => {
            handleClose();
          }}
          successEventData={successEventData}
          doNotGenerateHandler={doNotGenerateHandler}
          updateEventLoading={updateEventLoading}
        />
      )}
    </div>
  );
};
export default NewEvent;
